import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const MemberIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "MemberIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.4643 19.344H4.53574C3.13773 19.344 2 18.2062 2 16.8082V7.19175C2 5.79373 3.13773 4.65601 4.53574 4.65601H19.4643C20.8623 4.65601 22 5.79373 22 7.19175V16.8082C22 18.2062 20.8623 19.344 19.4643 19.344ZM4.53574 5.66557C3.69427 5.66557 3.00956 6.35027 3.00956 7.19175V16.8082C3.00956 17.6497 3.69427 18.3344 4.53574 18.3344H19.4643C20.3057 18.3344 20.9904 17.6497 20.9904 16.8082V7.19175C20.9904 6.35027 20.3057 5.66557 19.4643 5.66557H4.53574Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.7769 11.9073H15.1209C14.8419 11.9073 14.6161 11.6815 14.6161 11.4025C14.6161 11.1235 14.8419 10.8978 15.1209 10.8978H17.7769C18.0559 10.8978 18.2817 11.1235 18.2817 11.4025C18.2817 11.6815 18.0559 11.9073 17.7769 11.9073Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.7769 15.0942H15.1209C14.8419 15.0942 14.6161 14.8685 14.6161 14.5894C14.6161 14.3104 14.8419 14.0847 15.1209 14.0847H17.7769C18.0559 14.0847 18.2817 14.3104 18.2817 14.5894C18.2817 14.8685 18.0559 15.0942 17.7769 15.0942Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.1642 19.344H5.78832C5.50931 19.344 5.28354 19.1182 5.28354 18.8392V18.0958C5.28354 16.7175 6.40451 15.5965 7.78281 15.5965H10.1692C11.5475 15.5965 12.6689 16.7175 12.6689 18.0958V18.8392C12.6689 19.1182 12.4432 19.344 12.1642 19.344ZM6.29311 18.3344H11.6594V18.0958C11.6594 17.2746 10.9909 16.6061 10.1692 16.6061H7.78281C6.96155 16.6061 6.29311 17.2746 6.29311 18.0958V18.3344Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.97623 14.3208C7.91639 14.3208 7.05372 13.4581 7.05372 12.3983C7.05372 11.3384 7.91638 10.4763 8.97623 10.4763C10.0361 10.4763 10.8982 11.3384 10.8982 12.3983C10.8982 13.4581 10.0361 14.3208 8.97623 14.3208ZM8.97623 11.4858C8.47292 11.4858 8.06328 11.895 8.06328 12.3983C8.06328 12.9016 8.47292 13.3112 8.97623 13.3112C9.47954 13.3112 9.88869 12.9016 9.88869 12.3983C9.88869 11.895 9.47954 11.4858 8.97623 11.4858Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.4952 8.98559H2.50478C2.22577 8.98559 2 8.75982 2 8.48081C2 8.20179 2.22577 7.97602 2.50478 7.97602H21.4952C21.7742 7.97602 22 8.20179 22 8.48081C22 8.75982 21.7742 8.98559 21.4952 8.98559Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default MemberIcon;
